// extracted by mini-css-extract-plugin
export var container = "_5p-0";
export var error = "_5p-9";
export var label = "_5p-5";
export var light = "_5p-6";
export var md = "_5p-3";
export var sm = "_5p-2";
export var thin = "_5p-8";
export var thinBold = "_5p-7";
export var vertical = "_5p-4";
export var xs = "_5p-1";